import { Phone, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { servicePages } from "../data/servicePages";
import { industryPages } from "../data/industryPages";

const LOGO =
  "https://customer-assets.emergentagent.com/job_drone-survey-pro-4/artifacts/tzmknqwz_Snesar-Logo-1000%20%281%29.png";

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Footer = () => {
  return (
    <footer className="bg-[#10193f] text-white pt-16 pb-8" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid md:grid-cols-5 gap-10">
          <div className="md:col-span-1">
            <img
              src={LOGO}
              alt="Snesar Drone Services"
              className="h-10 w-auto bg-white rounded-sm p-1.5"
            />
            <p className="mt-5 text-sm text-white/70 leading-relaxed">
              Snesar Aerial Intelligence Pvt Ltd — survey-grade drone mapping,
              inspection and cinematic media. Founded 2018, Navi Mumbai.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-bold text-white mb-4">Services</h4>
            <ul className="space-y-2">
              {servicePages.map((p) => (
                <li key={p.slug}>
                  <Link
                    to={`/services/${p.slug}`}
                    data-testid={`footer-service-${p.slug}`}
                    className="text-sm text-white/70 hover:text-white transition-colors"
                  >
                    {p.nav}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-white mb-4">Industries</h4>
            <ul className="space-y-2">
              {industryPages.map((p) => (
                <li key={p.slug}>
                  <Link
                    to={`/industries/${p.slug}`}
                    data-testid={`footer-industry-${p.slug}`}
                    className="text-sm text-white/70 hover:text-white transition-colors"
                  >
                    {p.nav}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-white mb-4">Company</h4>
            <ul className="space-y-2">
              {[
                ["About", "#about"],
                ["Portfolio", "#portfolio"],
                ["Contact", "#contact"],
              ].map(([l, h]) => (
                <li key={h}>
                  <button
                    onClick={() => scrollTo(h)}
                    className="text-sm text-white/70 hover:text-white transition-colors"
                  >
                    {l}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-white mb-4">Contact</h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li className="flex items-center gap-3">
                <Phone className="h-4 w-4 text-[#8b8f99]" />
                <a href="tel:+917715972997" className="hover:text-white">
                  +91 7715972997
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-4 w-4 text-[#8b8f99]" />
                <a href="mailto:info@snesar.com" className="hover:text-white">
                  info@snesar.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 text-[#8b8f99] mt-0.5" />
                Navi Mumbai, Maharashtra, India
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/50">
            © {new Date().getFullYear()} Snesar Aerial Intelligence Pvt Ltd. All
            rights reserved.
          </p>
          <p className="text-xs text-white/50">Aerial Intelligence · Since 2018</p>
        </div>
      </div>
    </footer>
  );
};
